class Header {
  private header: string | null = null
  constructor(_header?: string) {
    this.header = _header || null
  }
  
  get = () => this.header
  set = (token: string) => { this.header = token }
  destroy = () => { this.header = null }
}

const HeadersManager = () => {
  const connectionId = new Header()
  const jwt = new Header()

  return {
    connectionId,
    jwt
  }
}

export default HeadersManager()